/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PoolCoinAddressResponse } from './pool-coin-address-response';


export interface PoolByIdResponse { 
    id: string;
    name: string;
    coinAddresses?: Array<PoolCoinAddressResponse> | null;
}

